import { useAuth } from "./useAuth";
import type { User } from "@shared/schema";

interface UseIsAdminReturn {
  isAdmin: boolean;
  isManagerOrAdmin: boolean;
  user: User | undefined;
  isAuthenticated: boolean;
}

export function useIsAdmin(): UseIsAdminReturn {
  const { user, isAuthenticated } = useAuth();

  const isAdmin = isAuthenticated && user?.role === 'admin';
  const isManagerOrAdmin = isAuthenticated && (user?.role === 'admin' || user?.role === 'manager');

  return {
    isAdmin,
    isManagerOrAdmin,
    user,
    isAuthenticated,
  };
}